<!-- TEMPLATE -->
<template>
  <div :class='addressesListClass'>
    <div class='row'>
      <div class='small-12 medium-12 large-12 hd-12 columns dashboard-content'>
        <dean-section-title content='true'>
          <span slot='title'>
            <span class='avenir-heavy'>Adressen</span>
          </span>

          <dean-section-title-item
            v-if="canCreateCustomerAddress()"
            :icon='plusIcon'
            :content="true"
            @click.native="sectionRoute('customer.address.add')"
          >
            Nieuw
          </dean-section-title-item>
        </dean-section-title>

        <dean-table
          :data='addressesData'
          :columns='columns'
          :hover="true"
          @column-click='columnClick'
          @cell-click="cellClick"
        >
        </dean-table>

        <dean-pagination
          :current-page='addressesMetaData.pageNumber'
          :total-items='addressesMetaData.totalResults'
          :items-per-page='addressesMetaData.itemsPerPage'
          :select-items-per-page='selectItemsPerPage'
          :visible-pages='addressesMetaData.visiblePages'
          @page-changed='paginationChanged'
          @items-per-page='itemsPerPageChanged'
        >
        </dean-pagination>
      </div>
    </div>
  </div>
</template>

<script lang='ts'>
  // VUE
  import {
    Vue,
    Component,
  } from 'vue-property-decorator';
  import axios from 'axios';
  import deanTableMixin from '@/mixins/deanTableMixin';
  import {mixins} from 'vue-class-component';
  import sideMenuCustomerMixin from '@/mixins/sideMenuCustomerMixin';

  import {
    // SVG
    invoicesIcon,
    // COMPONENTS
    deanTable,
    deanPagination,
    deanInputSelect,
    deanSectionDivider,
    deanSectionTitle,
    deanSectionTitleItem,
    deanSearchField,
    deanIcon,
    plusIcon,
    summeryIcon,
  } from '@deanone/dean-components';

  @Component({
    components: {
      deanPagination,
      deanTable,
      deanInputSelect,
      deanSectionDivider,
      deanSectionTitle,
      deanSectionTitleItem,
      deanSearchField,
      invoicesIcon,
      deanIcon,
      plusIcon,
      summeryIcon,
    },
  })
  export default class List extends mixins(deanTableMixin, sideMenuCustomerMixin) {

    public showSomething: boolean = false;
    public plusIcon: object = plusIcon;
    public data: object[] = [];

    // COMPUTED
    get addressesListClass() {
      let value = 'address-summary';
      if (this.showSomething) {
        value += ' no-scroll-container';
      }
      return value;
    }

    get addressesMetaData() {
      return this.pageMeta;
    }

    get addressesData() {
      return this.data;
    }

    public meta: object = {};

    public columns: any = {
      label: {
        content: 'label',
        align: 'left',
        sort: true,
        dql: 'label',
      },
      attention: {
        content: 't.a.v.',
        align: 'left',
        sort: true,
        dql: 'attention',
      },
      street: {
        content: 'straat',
        align: 'left',
        sort: true,
        dql: 'street',
      },
      houseNumber: {
        content: 'huisnummer + toevoeging',
        align: 'left',
        sort: true,
        dql: 'city',
      },
      postalCode: {
        content: 'postcode',
        align: 'left',
        sort: true,
        dql: 'postalCode',
      },
      city: {
        content: 'plaats',
        align: 'left',
        sort: true,
        dql: 'city',
      },
    };

    public cellClick(target: { cell: object, row: { id: string, personId: string }, column: string }) {
      this.$router.push({
        name: 'customer.address.edit',
        params: {addressId: target.row.id, pid: target.row.personId},
      });
    }

    public tableName(): string {
      return 'customer-addresses';
    }

    // METHODS
    public loadList(data: any) {
      this.$store.dispatch('setLoadOverlay', true);

      const url = '/-/trade/api/customer.addresses.list';

      axios.post(url, {
        id: this.$route.params.pid,
      }).then(
        (response) => {
          this.data = response.data.map((address: any) => {
            return {
              id: address.id,
              personId: this.$route.params.pid,
              label: address.label,
              attention: address.attention,
              street: address.street,
              houseNumber: address.houseNumber + (
                  address.houseNumberExtension ?
                      '-' + address.houseNumberExtension :
                      ''
              ),
              postalCode: address.postalCode,
              city: address.city,
            };
          });

          this.updateMeta(response.data.meta);
        },
        (error) => {
          this.$toast(this.$store.state.main.notification.messages.couldNotReceiveData);
        },
      ).finally(
        () => {
          this.$store.dispatch('setLoadOverlay', false);
        },
      );
    }

    public canCreateCustomerAddress(): boolean {
      if (this.$store.getters.getUser.privileges.includes('create-customer-address')) {
        return true;
      }

      return false;
    }

    public created() {
      this.setDefaultSort('label');
      this.loadList(this.pageMeta);
      this.buildSideMenuCustomer(this.$route.params.pid);
    }
  }
</script>

<!-- STYLE -->

<style lang='scss' scoped>
  @import '~@deanone/dean-components/src/scss/vars';
</style>

